import type { PurchaseCatalogProduct } from "../api/vouchers-distribution.types";
import type { PreparedCart } from "../models/prepared-cart";

const isPreparedCart = (value: unknown): value is PreparedCart => {
  if (typeof value !== "object" || value === null) return false;
  const { slug, products } = value as { slug?: unknown; products?: unknown };

  return (
    typeof slug === "string" &&
    Array.isArray(products) &&
    products.every(
      (product) =>
        typeof product === "object" && product !== null && typeof (product as { uuid?: unknown }).uuid === "string",
    )
  );
};

export const readPreparedCartFromGon = (): PreparedCart | undefined => {
  if (typeof window === "undefined") return undefined;
  const preparedCart = (window as unknown as { gon?: { preparedCart?: unknown } }).gon?.preparedCart;

  return isPreparedCart(preparedCart) ? preparedCart : undefined;
};

const initialPreparedCart = readPreparedCartFromGon();

export const getInitialPreparedCart = (): PreparedCart | undefined => initialPreparedCart;

const packagesFirst = (a: PurchaseCatalogProduct, b: PurchaseCatalogProduct) => {
  const rank = (product: PurchaseCatalogProduct) => (product.productType === "blood-test-package" ? 0 : 1);
  return rank(a) - rank(b);
};

export const selectPreparedCartCatalogProducts = (
  catalogProducts: PurchaseCatalogProduct[],
  preparedCart: PreparedCart,
): PurchaseCatalogProduct[] => {
  const catalogByUuid = new Map<string, PurchaseCatalogProduct>();
  for (const product of catalogProducts) {
    if (!catalogByUuid.has(product.uuid)) catalogByUuid.set(product.uuid, product);
  }

  const uuids = [...new Set(preparedCart.products.map((product) => product.uuid))];

  return uuids
    .map((uuid) => catalogByUuid.get(uuid))
    .filter((product): product is PurchaseCatalogProduct => product !== undefined)
    .sort(packagesFirst);
};
